import { combineReducers } from "redux";
import * as actionTypes from "../actionTypes/authTypes";

import auth from "./authReducer";
import events from "./eventsReducer";
import barCodes from "./barCodesReducer";
import promoter from "./promoterReducer";
import promoters from "./promotersReducer";
import scanteams from "./scanteamsReducer";
import payments from "./paymentReducer";
import canvas from "./canvasReducer";
import ticketGeneration from "./ticketGenerationReducer";
import eventData from "./EventDataReducer";
import { ticketsImport } from "./ticketsImportReducer";
import transactions from "./transactionsReducer";
import statistics from "./statisticsReducer";
import member from "./memberReducer";
import emailTemplates from "./emailTemplatesReducer";
import emails from "./emailsReducer";
import orders from "./orderReducer";

const appReducer = combineReducers({
  auth,
  events,
  ticketGeneration,
  canvas,
  emailTemplates,
  barCodes,
  promoter,
  promoters,
  scanteams,
  payments,
  eventData,
  ticketsImport,
  transactions,
  statistics,
  member,
  emails,
  orders,
});

const rootReducer = (state, action) => {
  if (action.type === actionTypes.LOGOUT_SUCCESS) {
    state = null;
  }

  return appReducer(state, action);
};

export default rootReducer;
